import React, { useState } from 'react';

const CHECKLIST = {
  whatsapp: [
    { label: 'Cuenta de Facebook Business', url: 'https://business.facebook.com/' },
    { label: 'Cuenta de WhatsApp Business verificada', url: 'https://www.facebook.com/business/help/2058515294227817' },
    { label: 'Método de pago agregado en Meta Business Manager', url: 'https://www.facebook.com/business/help/488043719225607' },
    { label: 'Número de teléfono NO registrado en WhatsApp', url: 'https://developers.facebook.com/docs/whatsapp/embedded-signup/pre-requisites' },
    { label: 'Acceso al número para recibir el código OTP', url: 'https://developers.facebook.com/docs/whatsapp/embedded-signup/pre-requisites' },
    { label: 'Nombre de empresa para mostrar en WhatsApp', url: 'https://developers.facebook.com/docs/whatsapp/guides/display-name' },
  ],
  instagram: [
    { label: 'Cuenta Instagram Business o Creator (no personal)', url: 'https://help.instagram.com/502981923235522' },
    { label: 'Página de Facebook vinculada a tu cuenta Instagram', url: 'https://help.instagram.com/570895513091465' },
    { label: 'Cuenta Facebook Business dueña de esa Página', url: 'https://business.facebook.com/' },
    { label: 'Mensajería habilitada en Instagram (Ajustes → Privacidad → Mensajes)', url: 'https://help.instagram.com/1724225214745082' },
  ],
};

const CHANNELS = [
  {
    slug: 'whatsapp',
    name: 'WhatsApp',
    description: 'Atiende clientes via WhatsApp Business',
    stroke: '#25d366',
    color: 'rgba(37,211,102,0.15)',
    icon: (stroke) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
  },
  {
    slug: 'instagram',
    name: 'Instagram',
    description: 'Atiende clientes via mensajes directos de Instagram',
    stroke: '#e1306c',
    color: 'rgba(225,48,108,0.15)',
    icon: (stroke) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <circle cx="12" cy="12" r="4"/>
        <circle cx="17.5" cy="6.5" r="0.5" fill={stroke}/>
      </svg>
    ),
  },
];

const s = {
  title: { fontSize: 17, fontWeight: 700, color: '#e2e2f0', marginBottom: 6 },
  sub: { fontSize: 13, color: '#6b6b8a', marginBottom: 20 },
  cardGrid: { display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 },
  btnPrimary: (disabled) => ({
    flex: 2, background: disabled ? '#4a2a8a' : 'linear-gradient(135deg,#7c3aed,#5b21b6)',
    color: 'white', border: 'none', borderRadius: 10, padding: '13px 0',
    fontSize: 14, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1, textAlign: 'center',
  }),
  btnSecondary: {
    flex: 1, background: 'transparent', border: '1px solid rgba(255,255,255,0.12)',
    color: '#888', borderRadius: 10, padding: '13px 0', fontSize: 14,
    cursor: 'pointer', textAlign: 'center',
  },
};

function ChannelCard({ channel, selected, onSelect, checked, onToggle }) {
  const isSelected = selected === channel.slug;
  return (
    <div>
      <div
        onClick={() => onSelect(channel.slug)}
        style={{
          border: isSelected ? `1px solid ${channel.stroke}` : '1px solid rgba(255,255,255,0.08)',
          borderRadius: isSelected ? '12px 12px 0 0' : 12,
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          background: isSelected ? channel.color : 'rgba(255,255,255,0.02)',
          cursor: 'pointer',
          transition: 'all 0.2s',
        }}
      >
        <div style={{
          width: 44, height: 44, borderRadius: 10, flexShrink: 0,
          background: channel.color,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {channel.icon(channel.stroke)}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ color: 'white', fontSize: 14, fontWeight: 600, marginBottom: 2 }}>{channel.name}</div>
          <div style={{ color: '#6b6b8a', fontSize: 12 }}>{channel.description}</div>
        </div>
        <div style={{
          width: 18, height: 18, borderRadius: '50%', flexShrink: 0,
          border: isSelected ? `2px solid ${channel.stroke}` : '2px solid #3a3a5c',
          background: isSelected ? channel.stroke : 'transparent',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {isSelected && (
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M2 5l2.5 2.5L8 3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
      </div>

      {isSelected && (
        <div style={{
          border: `1px solid ${channel.stroke}`,
          borderTop: 'none',
          borderRadius: '0 0 12px 12px',
          padding: '14px 20px',
          background: 'rgba(10,10,20,0.6)',
        }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10 }}>
            Necesitas tener listo:
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 7, marginBottom: 12 }}>
            {(CHECKLIST[channel.slug] || []).map((item, i) => {
              const done = checked.has(i);
              return (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, cursor: 'pointer' }} onClick={() => onToggle(i)}>
                  <div style={{
                    width: 16, height: 16, borderRadius: '50%', flexShrink: 0, marginTop: 1,
                    border: done ? `2px solid ${channel.stroke}` : '1.5px solid #3a3a5c',
                    background: done ? channel.stroke : 'transparent',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 0.15s',
                  }}>
                    {done && (
                      <svg width="9" height="9" viewBox="0 0 9 9" fill="none">
                        <path d="M1.5 4.5l2 2 4-4" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </div>
                  <a
                    href={item.url} target="_blank" rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{ fontSize: 12, color: done ? '#555' : '#c4b5fd', lineHeight: 1.5, textDecoration: done ? 'line-through' : 'none', transition: 'all 0.15s' }}
                    onMouseOver={e => { if (!done) e.target.style.textDecoration = 'underline'; }}
                    onMouseOut={e => { if (!done) e.target.style.textDecoration = 'none'; }}
                  >
                    {item.label}
                  </a>
                </div>
              );
            })}
          </div>
          <a
            href={`/redeem/guide/${channel.slug}`}
            style={{ fontSize: 12, color: '#a78bfa', fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}
          >
            Ver guía paso a paso →
          </a>
        </div>
      )}
    </div>
  );
}

export default function Step2bChannel({ wizard }) {
  const { selectedChannel, setSelectedChannel, setConnectedIntegrations } = wizard;
  const [checked, setChecked] = useState(new Set());

  function handleSelect(slug) {
    if (slug !== selectedChannel) {
      setConnectedIntegrations(new Set());
      setChecked(new Set());
    }
    setSelectedChannel(slug);
  }

  function toggleCheck(i) {
    setChecked(prev => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });
  }

  const total = selectedChannel ? (CHECKLIST[selectedChannel] || []).length : 0;
  const allChecked = selectedChannel && checked.size === total;
  const canContinue = !!selectedChannel && allChecked;

  return (
    <div>
      <div style={s.title}>Elige tu canal de atención</div>
      <div style={s.sub}>Selecciona por donde quieres atender a tus clientes.</div>

      <div style={s.cardGrid}>
        {CHANNELS.map((ch) => (
          <ChannelCard
            key={ch.slug}
            channel={ch}
            selected={selectedChannel}
            onSelect={handleSelect}
            checked={checked}
            onToggle={toggleCheck}
          />
        ))}
      </div>

      <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
        <button onClick={() => wizard.goToStep(2)} style={s.btnSecondary}>← Atrás</button>
        <button
          onClick={() => wizard.goToStep(4)}
          disabled={!canContinue}
          style={s.btnPrimary(!canContinue)}
        >
          Continuar →
        </button>
      </div>
    </div>
  );
}
